import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { of } from 'rxjs';
import { DataStateEnum } from 'src/app/enumeration/dataState.enum';
import { OpeExt } from 'src/app/models/OpeExt';
import { OpeService } from 'src/app/services/ope/ope.service';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';

@Component({
  selector: 'app-form-programme',
  templateUrl: './form-programme.component.html',
  imports: [CommonModule,FormsModule,ToastModule,ButtonModule,ReactiveFormsModule,InputTextModule,SelectButtonModule,SelectModule,ButtonModule,TableModule],
  styleUrls: ['./form-programme.component.scss'],
  providers: [MessageService]
})
export class FormProgrammeComponent implements OnInit {
  programmes!: any[];
  selectedProgrammes: OpeExt[] = [];
  btnDisabled = true;
  displayForm = true;
  listeOpeExt!: OpeExt[];
  entite!: any;

  constructor(private messageService: MessageService, private fb: FormBuilder, private share: shareOpeSevices, private oservice: OpeService) {

  }

  checkProgramme(event: any) {


    if (this.selectedProgrammes.length == 0) {
      this.btnDisabled = true;
    } else {
      this.btnDisabled = false;
    }
  };

  submitForm() {
    this.oservice.addAffectationOpeEntite(this.selectedProgrammes, this.entite.id, "BEN77868").subscribe((data: any) => {

      if (data === 1) {
        this.selectedProgrammes.length = 0
        this.btnDisabled = true;
        this.messageService.add({ severity: 'success', detail: "Programmes ajoutés aves Succes !" });
        this.entiteForm.reset;
        this.share.noeudficheEntite$.subscribe({
          next: ((resultat: any) => {
            this.entite = resultat?.data;
            this.oservice.getOpeExtravNonAffecte(resultat?.data?.id).subscribe({

              next: ((data: OpeExt[]) => {
                this.listeOpeExt = [...data];
                (this.listeOpeExt);
                this.programmes = [{ id: '', libelle: '' }]
                this.listeOpeExt.forEach(resultat => {
                  this.programmes.push(
                    {
                      numOpe: resultat.numOpe,
                      nom: resultat.nom
                    })
                })
              }), error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })
            });

          }),
          error: (err) => of({ dataStatut: "", errorMessage: err.error.message })
        });
      }
      else {

        this.messageService.add({ severity: 'warn', detail: "Erreur lors de l'ajout" });

      }
    })

  }

  ngOnInit() {

    this.btnDisabled = true;
    this.share.noeudficheEntite$.subscribe({
      next: ((resultat: any) => {
        this.entite = resultat?.data;
        this.oservice.getOpeExtravNonAffecte(resultat?.data?.id).subscribe({

          next: ((data: OpeExt[]) => {
            this.listeOpeExt = [...data];

            this.programmes = [{ id: '', libelle: '' }]

            this.listeOpeExt.forEach(resultat => {
              this.programmes.push(
                {
                  numOpe: resultat.numOpe,
                  nom: resultat.nom
                })
            })
          }), error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })
        });

      }),
      error: (err) => of({ dataStatut: "", errorMessage: err.error.message })
    }).unsubscribe;

  }

  entiteForm = this.fb.group({
    nom: ['', Validators.required],
    prenom: ['', Validators.required],

  });
}
